import { getOffersOut } from '../offers/apiHelpers';

export const offersOutLoader = () => getOffersOut();
